
import { defineComponent } from "vue";
import PasswordUpdate from "@/client/components/password/Update.vue";

export default defineComponent({
  components: {
    PasswordUpdate,
  },
});
